import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const testimonialsData = [
  { name: 'Edward Francener', company: 'MISTRAL CLEANING SERVICES', text: 'Their strategic advice for my business proved a savior for me. I am incredibly grateful for their reliable partnership and guidance.', delay: 0 },
  { name: 'Ruslan Urmanav', company: 'URBAN RENT A CAR', text: 'These guys are absolutely excellent in their work! I highly recommend them for financial advisory!', delay: 100 },
  { name: 'Mr Sharad', company: 'SHAIRA TRADING LLC', text: 'Their financial expertise was the lifeline my business needed to escape a financial crisis.', delay: 200 },
  { name: 'Mr Sanit', company: 'ADORE FRIGHT', text: 'Their exceptional financial insights and support pulled my business out of a monetary abyss.', delay: 300 },
  { name: 'Mr Anand', company: 'APPAM CORNER RESTAURANT', text: 'Their financial acumen and guidance were instrumental in rescuing my business from financial turmoil.', delay: 400 },
];

const Testimonials = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true, easing: 'ease-in-out' });
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getCardWidth = () => {
    if (windowWidth >= 1024) return '30%'; // desktop
    if (windowWidth >= 768) return '45%'; // tablet
    return '90%'; // mobile
  };

  const styles = {
    section: { padding: '5rem 0', backgroundColor: '#7d94a6ff' },
    container: { maxWidth: '1200px', margin: '0 auto', padding: '0 15px' },
    title: { textAlign: 'center', fontWeight: 'bold', marginBottom: '3rem', color: '#2c5aa0', fontSize: '2.5rem' },
    row: { display: 'flex', flexWrap: 'wrap', gap: '1.5rem', justifyContent: 'center' },
    card: { flex: '0 0 auto', width: getCardWidth(), padding: '1.5rem', backgroundColor: '#f0f4ff', border: '1px solid #d0e0ff', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)', transition: 'transform 0.3s ease' },
    cardBody: { padding: '0', textAlign: 'center' },
    name: { color: '#2c5aa0', fontWeight: 'bold', marginBottom: '0.25rem' },
    company: { fontSize: '0.9rem', color: '#1e4080', fontWeight: '500', marginBottom: '0.75rem' },
    text: { fontStyle: 'italic', color: '#555', margin: '0' },
  };

  return (
    <section id="testimonials" style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.title} data-aos="fade-up">Testimonials</h2>
        <div style={styles.row}>
          {testimonialsData.map((testimonial, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={testimonial.delay}
              style={styles.card}
            >
              <div style={styles.cardBody}>
                <h5 style={styles.name}>{testimonial.name}</h5>
                <p style={styles.company}>{testimonial.company}</p>
                <p style={styles.text}>{testimonial.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
